import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => (
  <section className="bt-not-found" aria-labelledby="not-found-title">
    <p className="bt-section-label">404</p>
    <h1 id="not-found-title">Page not found</h1>
    <p>That URL doesn’t match a launch, vehicle, or page on Booster Tracker.</p>
    <Link className="bt-not-found-link" to="/">
      Back to home
    </Link>
  </section>
);

export default NotFound;
